import { setAccessToken } from '@readcloud/api-client';
import React from 'react';

export type AuthContext = {
  email: string;
  firstName: string;
  lastName: string;
  accessToken: string;
};

const ctx = React.createContext<AuthContext | null>(null);

/**
 * Use this to provide auth to CloudsAndContent. The introduction of this means it doesn't need to directly depend on redux,
 * stories can be rendered using a mock, and components can be reliably tested.
 */
export function CloudsAndContentAuthProvider(props: {
  auth: AuthContext;
  children: React.ReactNode;
}) {
  setAccessToken(props.auth?.accessToken);

  return <ctx.Provider value={props.auth}>{props.children}</ctx.Provider>;
}

export function useAuth() {
  const auth = React.useContext(ctx);
  if (!auth) {
    throw Error('Tried to use auth context without it being provided');
  }
  return auth;
}
